import { PatientDoc } from './patient-doc.component';
import { PatientDocsList } from './patient-docs-list';
import { usePatientDocs } from './use-patient-docs.hook';

export function PatientDocsView() {
  const { patientDocument } = usePatientDocs();

  if (patientDocument !== undefined) {
    return <PatientDoc document={patientDocument} />;
  }

  return <PatientDocsList />;
}
